import React from 'react';
import PropTypes from 'prop-types';

const CustomToast = ({
    icon,
    text,
    textColor,
    backgroundColor,
    url,
    closeToast,
}) => {
    return (
        <div style={{ color: textColor }}>
            {url ? (
                <a
                    href={url}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                        color: textColor,
                        textDecoration: 'none',
                        fontSize: '14px',
                    }}
                    dangerouslySetInnerHTML={{
                        __html: text,
                    }}
                ></a>
            ) : (
                <p
                    style={{ fontSize: '14px' }}
                    dangerouslySetInnerHTML={{
                        __html: text,
                    }}
                ></p>
            )}
        </div>
    );
};

CustomToast.propTypes = {
    icon: PropTypes.string,
    text: PropTypes.string,
    textColor: PropTypes.string,
    backgroundColor: PropTypes.string,
    url: PropTypes.string,
    closeToast: PropTypes.func,
};

export default CustomToast;
